import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";
import { useTheme } from "styled-components";

import { ICh_Choir } from "../../../../../common/types/choir/choir";
import { get } from "../../../../actions/general";

import ChoirCard from "./ChoirCard";
import {  ListAligner, ListHolder, NoResultChoirs } from "./styles";
import messages from "./messages";

const Choirs = () => {
    const theme = useTheme();
    const [choirs, setChoirs] = useState<ICh_Choir[] | undefined>(undefined);
    const dispatch = useDispatch();

    const getChoirs = () => {
        dispatch(get<ICh_Choir[]>('choirs', (res) => {
            setChoirs(res.data);
        }));
    }

    useEffect(() => {
        getChoirs();
    }, []);

    const wrapperStyles = {
        backgroundColor: theme.c.snow,
        padding: '24px 0',
    }
    if (!choirs) {
        return (
            <div style={wrapperStyles}>
                <ListAligner>
                    <ListHolder>
                        {Array.from({ length: 3 }).map((_, i) => (
                            <ChoirCard
                                key={i}
                            />
                        ))}
                    </ListHolder>
                </ListAligner>
            </div>
        );
    }

    return (
        <div style={wrapperStyles}>
            <ListAligner>
                {choirs.length === 0 && (
                    <NoResultChoirs>
                        <FormattedMessage {...messages.noResults} />
                    </NoResultChoirs>
                )}
                {choirs.length > 0 && (
                    <ListHolder>
                        {choirs.map(choir => (
                            <ChoirCard
                                key={choir._id}
                                choir={choir}
                            />
                        ))}
                    </ListHolder>
                )}
            </ListAligner>
        </div>
    )
};

export default Choirs;
